export enum CostAccountingStateEnum {
    INITIALIZED = 'INITIALIZED',
    COST_TYPE_ACCOUNTING = 'COST_TYPE_ACCOUNTING',
    COST_CENTER_APPORTIONMENTS = 'COST_CENTER_APPORTIONMENTS',
    COST_UNIT_ACCOUNTING = 'COST_UNIT_ACCOUNTING',
}
